export default "__VITE_ASSET__DECBrh25__"